import { Grid } from "@mui/material";
import CirculationStatistics from "./Circulation/CirculationStatistics";
import MaterialStatistics from "./Material/MaterialStatistics";
import MemberStatistics from "./Member/MemberStatistics";
import VisitorStatistics from "./Visitors/VisitorStatistics";

const Index = () => {
  return (
    <>
      <Grid container spacing={2.5} sx={{ mb: 4 }}>
        <Grid item sm={12} md={10} xs={12}>
          <MemberStatistics />
        </Grid>
        <Grid item sm={12} md={2} xs={12}>
          <VisitorStatistics />
        </Grid>
      </Grid>
      <MaterialStatistics />
      <CirculationStatistics />
    </>
  );
};
export default Index;
